/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const WORKFLOW_1_6 = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": { areaName: "Area 1", },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [-73.91773056612587, 40.8258438247607],
                        [-74.03411697970009, 40.8258438247607],
                        [-74.03411697970009, 40.680460897621536],
                        [-73.91773056612587, 40.680460897621536],
                        [-73.91773056612587, 40.8258438247607]
                    ]
                ]
            },
        }
    ]
};

export default WORKFLOW_1_6